import { useMutation } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { importAanvraag } from '../services/importAanvraag'

export { useImportAanvraag }

const useImportAanvraag = () => {
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: importAanvraag,
    onSuccess: () => {
      successAlert('Aanvraag succesvol geïmporteerd')
    },
  })
}
